// src/components/Boxes/PurpleMan/purpleMan.component.jsx
import React, { useEffect, useState } from "react";
import "./purpleMan.style.scss";
import { useNavigate } from "react-router-dom";
import RNFBox from "../../Universals/RNFBox/RNFBox.component";
import { useDataLayer } from "../../../Contexts/DataLayer.context";
import NotDragable from "../../Universals/DragBox/notDragBox.component";
import {
  getTokenFromLocalStorage,
  getUserFromToken,
  saveAuthUser,
  forceLogoutToLogin
} from "../../../utils/functions.ts";
import { useMask } from "../../../Contexts/mask.context";
import { version } from "../../../Contexts/variables.jsx";

const AUTO_SCROLL_STORAGE_KEY = "FBX_ONE_LINER_AUTO_SCROLL";
const AUTO_SCROLL_EVENT = "FBX_ONE_LINER_AUTO_SCROLL_CHANGE";
const SHOW_SCROLLBARS_STORAGE_KEY = "FBX_ONE_LINER_SHOW_SCROLLBARS";
const SHOW_SCROLLBARS_EVENT = "FBX_ONE_LINER_SHOW_SCROLLBARS_CHANGE";
const RESET_WINDOW_POSITION_EVENT = "FBX_RESET_WINDOW_POSITION";

const MOVABLE_WINDOWS = [
  { label: "S1 Search", storageKey: "S1SEARCH_DRAGBOX_POS_2026" },
  { label: "S2 Search", storageKey: "S2SEARCH_DRAGBOX_POS_2026" },
  { label: "Lists", storageKey: "littleBoxPosition" },
  { label: "Shared Lists", storageKey: "L2_BUTTON_LOCATION" },
  { label: "Saved Query", storageKey: "SQ_BOX_LOCATION" },
  { label: "Alerts", storageKey: "Alert_BOX_LOCATION" },
  { label: "BluBars", storageKey: "FBX_BLUE_TRANSACTION_DRAG", adminOnly: true },
  { label: "Shared Notes", storageKey: "SHARED_NOTE_POSITION" },
  { label: "Overview", storageKey: "OVERVIEW_BOX_LOCATION" },
  { label: "Add/Edit", storageKey: "TOM_BOX_LOCATION", adminOnly: true },
  { label: "Hard Data", storageKey: "HD_BOX_LOCATION" },
];

const PurpleManBox = ({ onClose, onLogout, buttonID }) => {
  const navigate = useNavigate();
  const [formattedExpiration, setFormattedExpiration] = useState("");
  const [theUser, setUserData] = useState({});
  const [newShareArray, changeNewShareArray] = useState([]);
  const [newShareOptionArray, changeNewShareOptionArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendingAlerts, setSendingAlerts] = useState(false);
  const [sendAlertStatus, setSendAlertStatus] = useState("");
  const [pendingAlertCount, setPendingAlertCount] = useState(null);
  const [pendingAlertError, setPendingAlertError] = useState("");
  const [showInstructions, setShowInstructions] = useState(false);
  const [showSection, setShowSection] = useState("");
  const [showWindowResetPanel, setShowWindowResetPanel] = useState(false);
  const [windowResetMessage, setWindowResetMessage] = useState("");
  const [oneLinerAutoScroll, setOneLinerAutoScroll] = useState(() => {
    try {
      return localStorage.getItem(AUTO_SCROLL_STORAGE_KEY) !== "Off";
    } catch {
      return true;
    }
  });
  const [oneLinerShowScrollbars, setOneLinerShowScrollbars] = useState(() => {
    try {
      return localStorage.getItem(SHOW_SCROLLBARS_STORAGE_KEY) === "On";
    } catch {
      return false;
    }
  });

  const { arrayOfShared, actualShared } = useDataLayer();
  const { mask, unmask } = useMask();

  const formatExpiryFromToken = (tokenIn) => {
    try {
      if (!tokenIn?.exp) return "";

      return new Date(tokenIn.exp * 1000)
        .toLocaleString("en-CA", {
          timeZone: "America/Toronto",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(",", "");
    } catch (e) {
      console.warn("Could not read token expiry:", e);
      return "";
    }
  };

  const formatAccountDateTime = (dateIn) => {
    try {
      if (!dateIn) return "";

      const normalized = String(dateIn).trim().replace(" ", "T");
      const date = new Date(normalized);
      if (Number.isNaN(date.getTime())) return String(dateIn);

      return date
        .toLocaleString("en-CA", {
          timeZone: "America/Toronto",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(",", "");
    } catch {
      return String(dateIn || "");
    }
  };

  useEffect(() => {
    try {
      mask();
    } catch {}

    return () => {
      try {
        unmask();
      } catch {}
    };
  }, [mask, unmask]);

  const handleClose = (event) => {
    try {
      unmask();
    } catch {}

    if (onClose) {
      onClose(event, buttonID);
    }
  };

  const signout = () => {
    try {
      unmask();
    } catch {}

    if (onClose) {
      onClose(null, buttonID);
    }

    if (onLogout) {
      onLogout();
      return;
    }

    forceLogoutToLogin();
  };

  useEffect(() => {
    (async () => {
      try {
        const user = await getUserFromToken();
        console.log(user);

        const cleanUserData = user?.newShare?.endsWith(",")
          ? user.newShare.slice(0, -1)
          : user?.newShare || "";

        const shareArray = cleanUserData ? cleanUserData.split(",") : [];

        const nextShareOptions = user?.newShareOption?.endsWith(",")
          ? user.newShareOption.slice(0, -1).split(",")
          : (user?.newShareOption || "").split(",").filter(Boolean);

        changeNewShareArray(shareArray);
        changeNewShareOptionArray(nextShareOptions);
        setUserData(user || {});
        setFormattedExpiration(formatExpiryFromToken(user));
        setLoading(false);
      } catch (e) {
        console.warn(e);
        setLoading(false);
      }
    })();
  }, []);

  const handleToggle = async (title) => {
    const newArray = newShareArray.includes(title)
      ? newShareArray.filter((item) => item !== title)
      : [...newShareArray, title];

    changeNewShareArray(newArray);
  };

  const extendClick = async () => {
    try {
      const response = await fetch("https://www.fbxchange.com/ReactPHP/purpleman.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          method: "extend",
          user: theUser?.scout,
          theValue: "-",
        }).toString(),
      });

      const data = await response.json();
      console.log("PurpleMan extend response:", data);

      if (data?.user) {
        try {
          const decodedExtendJwt = JSON.parse(
            atob(data.user.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
          );
          console.log("PurpleMan extend decoded JWT:", decodedExtendJwt);
          console.log("PurpleMan extend non-Yes show fields:", decodedExtendJwt.showFields || {});
        } catch (decodeError) {
          console.warn("PurpleMan extend JWT decode failed:", decodeError);
        }
      }

      if (data?.success && data?.user) {
        saveAuthUser(data.user);

        const freshToken = await getTokenFromLocalStorage();
        setFormattedExpiration(formatExpiryFromToken(freshToken));

        const freshUser = await getUserFromToken().catch(() => theUser);
        if (freshUser) {
          setUserData(freshUser);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const returnNLA = async () => {
    const newValue = theUser?.nla === "On" ? "Off" : "On";

    try {
      const response = await fetch("https://www.fbxchange.com/ReactPHP/purpleman.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          method: "changeNLA",
          user: theUser?.scout,
          theValue: newValue,
        }).toString(),
      });

      const data = await response.json();

      if (data?.success && data?.user) {
        saveAuthUser(data.user);

        const userData = await getUserFromToken();
        setUserData(userData || {});
        setFormattedExpiration(formatExpiryFromToken(userData));
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const setOpenOnSignIn = async (newValue) => {
    setUserData((s) => ({ ...s, showCalendar: newValue }));

    try {
      const response = await fetch("https://www.fbxchange.com/ReactPHP/purpleman.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          method: "changeCalendar",
          user: theUser?.scout,
          theValue: newValue,
        }).toString(),
      });

      const data = await response.json();

      if (data?.success && data?.user) {
        saveAuthUser(data.user);

        const userData = await getUserFromToken();
        setUserData(userData || {});
        setFormattedExpiration(formatExpiryFromToken(userData));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const toggleOneLinerAutoScroll = () => {
    const nextValue = !oneLinerAutoScroll;
    setOneLinerAutoScroll(nextValue);

    try {
      localStorage.setItem(AUTO_SCROLL_STORAGE_KEY, nextValue ? "On" : "Off");
      window.dispatchEvent(new Event(AUTO_SCROLL_EVENT));
    } catch (e) {
      console.warn("Could not save OneLiner AutoScroll setting:", e);
    }
  };

  const toggleOneLinerScrollbars = () => {
    const nextValue = !oneLinerShowScrollbars;
    setOneLinerShowScrollbars(nextValue);

    try {
      localStorage.setItem(SHOW_SCROLLBARS_STORAGE_KEY, nextValue ? "On" : "Off");
      window.dispatchEvent(new Event(SHOW_SCROLLBARS_EVENT));
    } catch (e) {
      console.warn("Could not save OneLiner scrollbar setting:", e);
    }
  };

  const resetWindowPosition = (windowItem) => {
    try {
      localStorage.removeItem(windowItem.storageKey);
      window.dispatchEvent(
        new CustomEvent(RESET_WINDOW_POSITION_EVENT, {
          detail: { storageKey: windowItem.storageKey },
        })
      );
      setWindowResetMessage(`${windowItem.label} position reset.`);
    } catch (e) {
      setWindowResetMessage(`Could not reset ${windowItem.label}.`);
      console.warn("Could not reset window position:", e);
    }
  };

  const resetAllWindowPositions = () => {
    try {
      visibleMovableWindows.forEach((windowItem) => {
        localStorage.removeItem(windowItem.storageKey);
        window.dispatchEvent(
          new CustomEvent(RESET_WINDOW_POSITION_EVENT, {
            detail: { storageKey: windowItem.storageKey },
          })
        );
      });
      setWindowResetMessage("All window positions reset.");
    } catch (e) {
      setWindowResetMessage("Could not reset all window positions.");
      console.warn("Could not reset all window positions:", e);
    }
  };

  const loadPendingAlertCount = async () => {
    try {
      const response = await fetch("https://www.fbxchange.com/ReactPHP/danSendMail.php?script=countFlush");
      if (!response.ok) {
        setPendingAlertError("count unavailable");
        return;
      }

      const data = await response.json();
      if (data?.success) {
        setPendingAlertCount(Number(data.count || 0));
        setPendingAlertError("");
      } else {
        setPendingAlertError(data?.error || "count unavailable");
      }
    } catch (error) {
      setPendingAlertError("count unavailable");
      console.warn("Could not load pending alert count:", error);
    }
  };

  const sendAlertMessages = async () => {
    if (sendingAlerts) return;

    const confirmed = window.confirm("Send all pending alert messages now?");
    if (!confirmed) return;

    setSendingAlerts(true);
    setSendAlertStatus("Sending alert messages...");

    try {
      const response = await fetch("https://www.fbxchange.com/ReactPHP/danSendMail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ script: "flushEmailTransactions" }),
      });

      const data = await response.json();
      const sentCount = Array.isArray(data?.sent) ? data.sent.length : 0;
      const failedCount = Array.isArray(data?.failed) ? data.failed.length : 0;

      if (data?.success) {
        setSendAlertStatus(`Sent: ${sentCount} | Failed: ${failedCount}`);
      } else {
        setSendAlertStatus(data?.error || `Alert send finished with ${failedCount} failure(s).`);
      }
      await loadPendingAlertCount();
    } catch (error) {
      setSendAlertStatus("Alert send failed. Check connection or server logs.");
      console.warn("Send alert messages failed:", error);
    } finally {
      setSendingAlerts(false);
    }
  };

  const isAdmin = String(theUser?.userContactLevel || "") === "1";
  const visibleMovableWindows = MOVABLE_WINDOWS.filter((windowItem) => !windowItem.adminOnly || isAdmin);

  useEffect(() => {
    if (isAdmin) {
      loadPendingAlertCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const RNFNote =
    "FBX and other contributing sources add Reports, Notes, and Files to the system. By Default, you only see the reports, notes, and files from your team, but if other sources are available, checking them will allow you to see reports, notes, and files from them as well.";

  const extendNote =
    "Extending your session will give you an additional 4 hours before you are automatically logged out. FBX automatically logs you out after 4 hours for your security.";

  const calendarNote = "Choose what opens automatically on Sign In.";
  const autoScrollNote =
    "When AutoScroll is On, the main OneLiner scrolls to the selected player after sorting or player changes. Notes and Reports one-liners are not affected.";
  const scrollbarsNote =
    "When Show Scrollbars is On, the main, notes, and reports one-liners show a draggable scrollbar on the right side. It is Off by default.";
  const resetWindowsNote =
    "Use Reset Window Positions if a movable window has been dragged off screen. Reset one window or all saved positions.";

  const showHelp = (inval) => {
    if (inval === "") {
      setShowInstructions(false);
      setShowSection("");
    } else {
      setShowInstructions(true);
      switch (inval) {
        case "RNF":
          setShowSection(RNFNote);
          break;
        case "NLA":
          setShowSection(
            "Each day when Transactions are added to the System, if you have Receive Neg List alert turned on, the system will automatically send you an email telling you of the new information (status) of the player on your Negotiation List"
          );
          break;
        case "Extend":
          setShowSection(extendNote);
          break;
        case "Calendar":
          setShowSection(calendarNote);
          break;
        case "AutoScroll":
          setShowSection(autoScrollNote);
          break;
        case "Scrollbars":
          setShowSection(scrollbarsNote);
          break;
        case "ResetWindows":
          setShowSection(resetWindowsNote);
          break;
        default:
          setShowSection("");
      }
    }
  };

  const openOnSignInValue = theUser?.showCalendar || "CAL";
  const accountInfoItems = [
    { label: "User", value: theUser?.displayName || "-" },
    { label: "Team", value: theUser?.team || "-" },
    { label: "Security", value: theUser?.userContactLevel || "-" },
    { label: "Times On", value: theUser?.timeOn || "-" },
    { label: "Last On", value: formatAccountDateTime(theUser?.lastOn) || "-" },
    { label: "Last IP", value: theUser?.lastIP || "-" },
    { label: "Auto Log Out", value: formattedExpiration || "N/A" },
    { label: "Version", value: version },
  ];

  return (
    <NotDragable
      centerScreen={true}
      title={`Account - ${theUser?.displayName || "PurpleMan"} | ${version}`}
      width={1080}
      addNote="-"
    >
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div style={{ flex: 1, overflow: "auto" }}>
          <div className="d-flex gap-3 p-2 fs-7">
            <div className="col-18 bg-purple p-2" style={{ minHeight: 330 }}>
              <div className="text-white text-center fw-bold">Account Panel Help</div>

              {!showInstructions ? (
                <div className="mb-2 d-flex flex-column align-items-center">
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light fs-7 w-100" onClick={() => showHelp("RNF")}>
                      RNF Sources
                    </div>
                  </div>
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("Extend")}>
                      Extend
                    </div>
                  </div>
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("NLA")}>
                      NLA
                    </div>
                  </div>
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("Calendar")}>
                      Open on Sign In
                    </div>
                  </div>
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("AutoScroll")}>
                      AutoScroll
                    </div>
                  </div>
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("Scrollbars")}>
                      Scrollbars
                    </div>
                  </div>
                  <div className="mt-2 col-30 offet-9">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("ResetWindows")}>
                      Window Reset
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-white p-3">
                  <p className="p-2 mt-2">
                    <div className="text-center">{showSection}</div>
                  </p>
                  <div className="col-24 offset-12 mt-auto">
                    <div className="btn btn-sm btn-light w-100" onClick={() => showHelp("")}>
                      OK
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-grow-1 p-2">
              <div className="purpleman-account-summary mb-2">
                {accountInfoItems.map((item) => (
                  <div className="purpleman-account-summary__item" key={item.label}>
                    <div className="purpleman-account-summary__label">{item.label}</div>
                    <div className="purpleman-account-summary__value" title={String(item.value || "")}>
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex gap-2 align-items-center purpleman-control-row">
                <div className="col-12 text-end">RNF Sources:</div>
                <div className="flex-grow-1 text-start">
                  <RNFBox buttonList={arrayOfShared} selectedButtons={actualShared} helpbutton={false} />
                </div>
              </div>

              <div className="d-flex gap-2 purpleman-control-row">
                <div className="col-12 text-end">
                  <div className="btn btn-sm btn-outline-purple w-100" onClick={extendClick}>
                    Extend
                  </div>
                </div>
                <div className="flex-grow-1 text-start">Auto Log Out: {formattedExpiration || "N/A"}</div>
              </div>

              <div className="d-flex gap-2 purpleman-control-row">
                <div className="col-12 text-end">
                  <div
                    className={`btn btn-sm ${theUser?.nla === "On" ? "btn-outline-success" : "btn-outline-danger"} w-100`}
                    onClick={returnNLA}
                  >
                    NLA
                  </div>
                </div>
                <div className={`${theUser?.nla === "On" ? "text-success fw-bold" : "text-danger"}`}>
                  Receive Neg List Alerts : {theUser?.nla}
                </div>
              </div>

              <div className="d-flex gap-2 align-items-center purpleman-control-row">
                <div className="col-12 text-end">
                  Open on Sign In:
                </div>
                <div className="flex-grow-1 text-start">
                  <select
                    className="form-select form-select-sm"
                    value={openOnSignInValue}
                    onChange={(e) => setOpenOnSignIn(e.target.value)}
                  >
                    <option value="-">Show Nothing</option>
                    <option value="CAL">Calendar</option>
                    <option value="S1">S1 Search</option>
                    <option value="S2">S2 Search</option>
                    <option value="L1">Lists</option>
                    <option value="L2">Shared Lists</option>
                    <option value="SQ">Saved Query</option>
                    <option value="SN">Shared Note</option>
                  </select>
                </div>
              </div>

              <div className="d-flex gap-2 purpleman-control-row">
                <div className="col-12 text-end">
                  <div
                    className={`btn btn-sm ${oneLinerAutoScroll ? "btn-outline-success" : "btn-outline-danger"} w-100`}
                    onClick={toggleOneLinerAutoScroll}
                  >
                    AutoScroll
                  </div>
                </div>
                <div className={`${oneLinerAutoScroll ? "text-success fw-bold" : "text-danger"}`}>
                  OneLiner AutoScroll : {oneLinerAutoScroll ? "On" : "Off"}
                </div>
              </div>

              <div className="d-flex gap-2 purpleman-control-row">
                <div className="col-12 text-end">
                  <div
                    className={`btn btn-sm ${oneLinerShowScrollbars ? "btn-outline-success" : "btn-outline-danger"} w-100`}
                    onClick={toggleOneLinerScrollbars}
                  >
                    Scrollbars
                  </div>
                </div>
                <div className={`${oneLinerShowScrollbars ? "text-success fw-bold" : "text-danger"}`}>
                  OneLiner Scrollbars : {oneLinerShowScrollbars ? "On" : "Off"}
                </div>
              </div>

              <div className="d-flex gap-2 purpleman-control-row">
                <div className="col-12 text-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-purple w-100"
                    onClick={() => {
                      setShowWindowResetPanel((prev) => !prev);
                      setWindowResetMessage("");
                    }}
                  >
                    Reset Windows
                  </button>
                </div>
                <div className="flex-grow-1 text-start">
                  Window Positions
                </div>
              </div>

              {showWindowResetPanel && (
                <div className="border rounded p-2 mb-2 bg-light">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div className="fw-bold flex-grow-1 text-start fs-8">Reset Window Positions</div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={resetAllWindowPositions}
                    >
                      Reset All
                    </button>
                  </div>

                  <div className="d-flex flex-wrap gap-2">
                    {visibleMovableWindows.map((windowItem) => (
                      <button
                        type="button"
                        key={windowItem.storageKey}
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => resetWindowPosition(windowItem)}
                      >
                        {windowItem.label}
                      </button>
                    ))}
                  </div>

                  {windowResetMessage && (
                    <div className="mt-2 text-success fw-bold fs-8 text-start">{windowResetMessage}</div>
                  )}
                </div>
              )}

              {isAdmin && (
                <div className="mt-2">
                  <div className="mb-1 text-start fs-8">
                    Pending Alert Messages: {pendingAlertError || (pendingAlertCount === null ? "..." : pendingAlertCount)}
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-purple w-100"
                      onClick={sendAlertMessages}
                      disabled={sendingAlerts}
                    >
                      {sendingAlerts ? "Sending..." : "Send Alert Messages"}
                    </button>
                  </div>
                  {sendAlertStatus && <div className="mt-1 text-start fs-8">{sendAlertStatus}</div>}
                </div>
              )}
            </div>
          </div>
        </div>

        <div style={{ borderTop: "1px solid rgba(0,0,0,0.08)", padding: 8 }}>
          <div className="d-flex align-items-center justify-content-center p-2 gap-3">
            <div className="col-16">
              <button className="btn btn-outline-secondary w-100 fs-6" onClick={handleClose}>
                Cancel / Close
              </button>
            </div>
            <div className="col-16">
              <button className="btn btn-outline-danger w-100 fs-6" onClick={signout}>
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </NotDragable>
  );
};

export default PurpleManBox;
